





























































































































import Vue from 'vue'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import VueMasonry from 'vue-masonry-css'
import Draggable from 'vuedraggable'
import PortfolioEtf from '~/models/PortfolioEtf'
import PortfolioShare from '~/models/PortfolioShare'
import PortfolioShareInterface from '~/models/PortfolioShareInterface'
import { PerformanceData } from '~/types/PerformanceData'
import { RiskData } from '~/types/RiskData'

Vue.use(VueMasonry)

export default Vue.extend({
	name: 'PortfolioOverview',
	components: { Draggable },
	data() {
		return {
			allComponents: [
				'portfolioPerformanceChart',
				'portfolioPreview',
				'geographicExposure',
			],
			currentComponents: {
				1: [
					[
						'portfolioPerformanceChart',
						'portfolioPreview',
						'marketcapExposure',
						'geographicExposure',
						'portfolioPerformanceData',
					],
				],
				2: [
					[
						'portfolioPerformanceChart',
						'marketcapExposure',
						'portfolioPerformanceData',
					],
					[
						'portfolioPreview',
						'geographicExposure',
					],
				],
				3: [
					[
						'portfolioPreview',
					],
					[
						'portfolioPerformanceChart',
						'portfolioPerformanceData',
					],
					[
						'marketcapExposure',
						'geographicExposure',
					],
				],
			} as { [cols: number]: string[][] },
			editing: false,
			componentTitles: {
				portfolioPerformanceChart: this.$t('portfolio.value-history'),
				portfolioPreview: this.$t('portfolio.positions'),
				marketcapExposure: this.$t('portfolio.marketcap-exposure'),
				geographicExposure: this.$t('portfolio.geographic-exposure'),
				portfolioPerformanceData: this.$t('portfolio.performance'),
			},
			addComponent: {
				show: false,
				colIndex: null as number|null,
				top: false,
			},
			cols: 2,
			colsEditing: 2,
			shares: [] as PortfolioShareInterface[],
			riskData: null as RiskData|null,
			performanceData: null as PerformanceData|null,
			loading: true,
		}
	},
	computed: {
		componentProps(): any {
			return {
				portfolioPerformanceChart: { shares: this.shares },
				portfolioPreview: { shares: this.shares },
				marketcapExposure: { riskData: this.riskData },
				geographicExposure: { riskData: this.riskData },
				portfolioPerformanceData: { performanceData: this.performanceData },
			}
		},
		componentReady(): any {
			return {
				portfolioPerformanceChart: true,
				portfolioPreview: true,
				marketcapExposure: this.riskData !== null,
				geographicExposure: this.riskData !== null,
				portfolioPerformanceData: this.performanceData !== null,
			}
		},
		availableComponents(): string[] {
			const active = this.currentComponents[this.cols].flat()
			return this.allComponents.filter((c) => !active.includes(c))
		},
		pageReady(): boolean {
			return (this.riskData && this.riskData.length > 0)
				|| (
					this.performanceData !== null
					&& (
						this.performanceData.averageEvEbitda !== null
						|| this.performanceData.averageRevenueGrowth !== null
						|| this.performanceData.averageEbitGrowth !== null
						|| this.performanceData.averageEpsGrowth !== null
					)
				)
		},
	},
	watch: {
		currentComponents: {
			deep: true,
			handler() {
				this.$auth.setUser({
					...this.$auth.user,
					preferences: {
						...(this.$auth.user?.preferences as any),
						'portfolio-components': this.currentComponents,
					},
				})
				this.$axios.put(
					'/api/user/preferences/portfolio-components',
					{ value: this.currentComponents },
				)
			},
		},
	},
	mounted() {
		this.checkWindowSize()
		this.loadShares()
		window.addEventListener('resize', this.checkWindowSize)

		const user = this.$auth.user as { preferences: { [key: string]: any } }

		if (user.preferences['portfolio-components']) {
			this.currentComponents = user.preferences['portfolio-components']
		}

		this.$axios.get('/api/user/portfolio/risk').then((res) => {
			this.riskData = res.data
			this.loading = false
		})

		this.$axios.get('/api/user/portfolio/performance').then((res) => {
			this.performanceData = res.data
			this.loading = false
		})
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.checkWindowSize)
	},
	methods: {
		remove(key: string, index: number) {
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			this.currentComponents[key].splice(index, 1)
		},
		checkWindowSize() {
			if (window.innerWidth >= 1920) {
				this.cols = 3
			} else if (window.innerWidth >= 900) {
				this.cols = 2
			} else {
				this.cols = 1
			}
		},
		loadShares() {
			this.$axios.get('/api/user/portfolio/shares?include_orders=1').then((resp) => {
				this.shares = PortfolioShare.sortDesc(resp.data.shares
					.map((share: any) => {
						if (share.etf) {
							return PortfolioEtf.deserialize(share)
						}

						return PortfolioShare.deserialize(share)
					}))
			})
		},
	},
})
